export const FIELD_NORMAL_LENGTH = 225

export const MAX_FIELD_LENGTH = 2048

export const SUGGESTED_FIELD_LENGTH = 1250

export const COGNITO_POOL_ID = 'us-east-2_jVPYX9Eex'
export const COGNITO_REGION = 'us-east-2'
export const COGNITO_CLIENT_ID = '5tr8vruucj4g5u2rm02le91rvu'
export const COGNITO_DOMAIN = 'https://casemed.auth.us-east-2.amazoncognito.com'
export const COGNITO_AUTHORITY = `https://cognito-idp.${COGNITO_REGION}.amazonaws.com/${COGNITO_POOL_ID}`
export const COGNITO_SCOPES = 'aws.cognito.signin.user.admin email openid phone profile'

export const INVOICER_ROLE_NAME = 'invoicer'

export const PEER_REVIEWER_ROLE_NAME = 'peer-reviewer'

export const SERVICE_PROVIDER_ROLE_NAME = 'service-provider'

export const CLAIM_REP_ROLE_NAME = 'claim-rep'

export const SOCIAL_WORKER_ROLE_NAME = 'social-worker'

export const CASE_MANAGER_ROLE_NAME = 'case-manager'

export const CASE_ADMIN_ROLE_NAME = 'case-admin'

export const ADMIN_ROLE_NAME = 'admin'

export const PROMPT_ENGINEER_ROLE_NAME = 'prompt-engineer'

export const ROLE_NAMES = [
  { key: INVOICER_ROLE_NAME, label: 'Invoicer' },
  { key: PEER_REVIEWER_ROLE_NAME, label: 'Peer Reviewer' },
  { key: SERVICE_PROVIDER_ROLE_NAME, label: 'Service Provider' },
  { key: CLAIM_REP_ROLE_NAME, label: 'Claims Adjuster' },
  { key: SOCIAL_WORKER_ROLE_NAME, label: 'Social Worker' },
  { key: CASE_MANAGER_ROLE_NAME, label: 'Case Manager' },
  { key: CASE_ADMIN_ROLE_NAME, label: 'Case Admin' },
  { key: ADMIN_ROLE_NAME, label: 'Admin' },
  { key: PROMPT_ENGINEER_ROLE_NAME, label: 'Prompt Engineer' },
]

export const MEDICAL_RECORD_SUBTYPES = [
  { value: 'Diagnostic Study', label: 'Diagnostic Study', description: 'MRI, CT, X-Ray, Ultrasound' },
  { value: 'Operative Report', label: 'Operative Report', description: 'Surgical procedures & post-op summaries' },
  {
    value: 'Office Visit Note',
    label: 'Office Visit Note',
    description: 'Treating physician progress note / SOAP note',
  },
  {
    value: 'Physical Therapy',
    label: 'Physical Therapy',
    description: 'PT/OT evaluations, daily notes, discharge summaries',
  },
  {
    value: 'Independent Medical Exam',
    label: 'Independent Medical Exam',
    description: 'IME, QME, AME legal-medical evaluations',
  },
  { value: 'Emergency Care', label: 'Emergency Care', description: 'Emergency Department / Urgent Care triage' },
  { value: 'Electrodiagnostic Study', label: 'Electrodiagnostic Study', description: 'EMG / Nerve Conduction Studies' },
  {
    value: 'Functional Capacity Exam',
    label: 'Functional Capacity Exam',
    description: 'FCE physical demand evaluations',
  },
  { value: 'Pathology / Lab Report', label: 'Pathology / Lab Report', description: 'Lab tests, bloodwork, biopsies' },
  {
    value: 'Other Medical Note',
    label: 'Other Medical Note',
    description: 'General medical correspondence or miscellaneous notes',
  },
]

export const MEDICAL_RECORD_SUBTYPE_MAP = MEDICAL_RECORD_SUBTYPES.reduce((acc, item) => {
  acc[item.value] = `${item.label}: ${item.description}`
  return acc
}, {})

export const ARCHETYPE_CATEGORY_PRIORITIES = {
  'Diagnostic Study': [
    'test',
    'provider',
    'referral',
    'demographics',
    'status',
    'medication',
    'diagnosis',
    'appointment',
    'surgery',
  ],
  'Electrodiagnostic Study': [
    'test',
    'provider',
    'referral',
    'demographics',
    'status',
    'medication',
    'diagnosis',
    'appointment',
    'surgery',
  ],
  'Operative Report': [
    'surgery',
    'provider',
    'diagnosis',
    'medication',
    'status',
    'test',
    'appointment',
    'referral',
    'demographics',
  ],
  'Independent Medical Exam': [
    'status',
    'provider',
    'diagnosis',
    'test',
    'referral',
    'demographics',
    'medication',
    'appointment',
    'surgery',
  ],
  'Physical Therapy': [
    'status',
    'appointment',
    'provider',
    'diagnosis',
    'test',
    'referral',
    'demographics',
    'medication',
    'surgery',
  ],
  'Emergency Care': [
    'diagnosis',
    'test',
    'provider',
    'medication',
    'referral',
    'demographics',
    'status',
    'appointment',
    'surgery',
  ],
  'Office Visit Note': [
    'diagnosis',
    'provider',
    'medication',
    'test',
    'appointment',
    'status',
    'referral',
    'demographics',
    'surgery',
  ],
  'Pathology / Lab Report': [
    'test',
    'provider',
    'diagnosis',
    'medication',
    'referral',
    'demographics',
    'status',
    'appointment',
    'surgery',
  ],
  'Functional Capacity Exam': [
    'status',
    'provider',
    'test',
    'diagnosis',
    'referral',
    'demographics',
    'medication',
    'appointment',
    'surgery',
  ],
}
